import React, { useContext } from 'react';
import PaperSection from '../../../../components/PaperSection/PaperSection';
import { Box } from '@mui/material';
import LiquidityBreakdownTable, { LiquidityBreakdownRowData } from './LiquidityBreakdownTable';
import { ReportContext } from '../../../../common/reportContext';

const LiquidityBreakdown = () => {
  const { report } = useContext(ReportContext);
  const data = report.cashBoard.liquidityBreakdown;

  const rows: LiquidityBreakdownRowData[] = [
    {
      type: "All accounts",
      accounts: data.allAccounts.accounts,
      interest: data.allAccounts.periodInterest,
      yield: data.allAccounts.yieldPercent,
      balances: data.allAccounts.averageBalance,
      funds: data.allAccounts.percentOffunds
    },
    {
      type: "No Yield- Liquid Dollars",
      accounts: data.noYieldLiquidDollars.accounts,
      interest: data.noYieldLiquidDollars.periodInterest,
      yield: data.noYieldLiquidDollars.yieldPercent,
      balances: data.noYieldLiquidDollars.averageBalance,
      funds: data.noYieldLiquidDollars.percentOffunds
    },
    {
      type: "Liquid Dollars",
      accounts: data.liquidDollars.accounts,
      interest: data.liquidDollars.periodInterest,
      yield: data.liquidDollars.yieldPercent,
      balances: data.liquidDollars.averageBalance,
      funds: data.liquidDollars.percentOffunds
    },
    {
      type: "Fixed Income",
      accounts: data.fixedIncome.accounts,
      interest: data.fixedIncome.periodInterest,
      yield: data.fixedIncome.yieldPercent,
      balances: data.fixedIncome.averageBalance,
      funds: data.fixedIncome.percentOffunds
    }
  ];

  return (
    <PaperSection title="Liquidity Breakdown">
      <Box sx={{ width: '100%' }}>
        <LiquidityBreakdownTable rows={rows} />
      </Box>
    </PaperSection>
  );
};

export default LiquidityBreakdown;

